import { render, staticRenderFns } from "./CourseManagement.vue?vue&type=template&id=171f59ba"
import script from "./CourseManagement.vue?vue&type=script&lang=js"
export * from "./CourseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports